import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class DonationmaintypeService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  
  GetDonationMainType():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationMainType/Get`);
  }

  DeleteDonationMainType(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationMainType/Delete?id=${id}`);
  }

  CreateDonationMainType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationMainType/Create`,data);
  }
  UpdateDonationMainType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationMainType/Update`,data)
  }
}
